(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9642],{

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MigriWidget; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ./src/magnolia/components/MigriWidget/MigriWidget.module.scss
var MigriWidget_module = __webpack_require__(3833);
var MigriWidget_module_default = /*#__PURE__*/__webpack_require__.n(MigriWidget_module);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
;// CONCATENATED MODULE: ./src/magnolia/components/MigriWidget/MigriWidget.tsx






function MigriWidget() {
    var iframeStyle = {
        width: "100%",
        height: "100%",
        border: "none"
    };
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B.Content, {
            limitedWidth: viewport === "xl" ? true : false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getStyleClassName(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    id: "migri-iframe",
                    src: "https://migri.fi-t.seravo.com/en/employee/",
                    title: "guide on how to apply for a residence permit",
                    style: iframeStyle
                })
            })
        })
    });
}
function getStyleClassName() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return (MigriWidget_module_default())[[
        "migri-container"
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).join("__")];
}

;// CONCATENATED MODULE: ./src/magnolia/components/MigriWidget/index.ts



/***/ }),

/***/ 3833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"migri-container":"MigriWidget_migri-container__77DYc"};

/***/ })

}]);